import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Files = lazy(() => import('es/app/views/site/files'));

export function FileRoutes() {
    return (
        <>
            {[siteMap.files.search(), siteMap.files.searchDeep()].map(route => (
                <Route path={route} key={route} element={<Files />} ErrorBoundary={RouteErrorBoundary} />
            ))}
        </>
    );
}
